import { Typography } from "@material-ui/core"
import React, { FunctionComponent } from "react"

interface MaxOperationsRemaininglabelProps {
    maxOperations: number
    currentOperations: number
}

export const MaxOperationsRemainingLabel: FunctionComponent<MaxOperationsRemaininglabelProps> = ({
    maxOperations,
    currentOperations
}) => {
    return (
        <Typography variant="body2">
            {`${maxOperations - currentOperations} operations remaining`}
        </Typography>
    )
}
